import { TippyDirective } from '@/directives/tippy.directive';
import { Component, ViewChild, TemplateRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Web3Service } from '@/services/web3.service';
import { ThemeService } from '@/services/theme.service';
import { StateService } from '@/services/state.service';
import { BehaviorSubject, combineLatest, firstValueFrom, map, shareReplay } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { FormatCashPipe } from '@/pipes/format-cash.pipe';
import { LoaderComponent } from '../icons/loader.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { TokenIdParsePipe } from '@/pipes/token-id-parse.pipe';
import { DataService } from '@/services/data.service';
import { MessagingService } from '@/services/messaging.service';
import { environment } from 'src/environments/environment';
import { RouterModule } from '@angular/router';


@Component({
  selector: 'app-header-icons',
  templateUrl: './header-icons.component.html',
  styleUrls: ['./header-icons.component.scss'],
  standalone: true,
  imports: [CommonModule, FormatCashPipe, RouterModule, TippyDirective, LoaderComponent, LazyLoadImageModule, TokenIdParsePipe]
})
export class HeaderIconsComponent {

  protected readonly environment = environment;
    
  private manualSearchBarState = new BehaviorSubject<boolean>(false);
  cigMenuOpen = false;

  @Input() isInSideMenu = false;

  constructor(
    public web3Svc: Web3Service,
    public dataSvc: DataService,
    public stateSvc: StateService,
    public themeSvc: ThemeService,
    public msgSvc: MessagingService,
  ) {}

  async switchTheme(): Promise<void> {
    const theme = await firstValueFrom(this.themeSvc.theme$);
    this.themeSvc.setTheme(theme === 'dark' ? 'light' : 'dark');
  }


  toggleSearchBar(): void {
    const currentValue = this.manualSearchBarState.value;
    this.manualSearchBarState.next(!currentValue);
  }

  /** Collapse the slide-out menu (tablet/mobile); no-op when already closed. */
  closeSideMenu(): void {
    this.stateSvc.setMenuOpen(false);
  }

} 